import _				from "lodash";

import Service			from "./../../Libs/Service";

import { AIAgentVoiceInput }	from "./AIAgent.VoiceInput";
import { AIAgentAttachments }	from "./AIAgent.Attachments";
import { AIAgentMessages }		from "./AIAgent.Messages";

let AIAgent = new Service({

	Name: "AIAgent",

	Libraries: [AIAgentVoiceInput, AIAgentAttachments, AIAgentMessages],

	Events: {

		//Переключение рабочей ноды: активные карты данных подменяются картами этой ноды
		"Cluster Working Node Changed": function(previousServerId, serverId) {

			this.useServer(serverId);

		},

		// При разрыве соединения сервер забывает какие чаты запрашивал клиент - нужно забыть и загруженные сообщения чтобы запросить их заново
		"Socket Connection Closed": function() {

			_.each(_.keys(this.AIAgentMessages), chatId => delete this.AIAgentMessages[chatId]);
			this.requestedAIAgents = {};
			this.AgentProcessing = {};

			Broadcast.call("AI Chat Agent State Changed");

		}

	},

	Actions: {

		// Все чаты креатива (приходят при первом открытии креатива)
		// serverId - нода, с которой пришли данные
		"AIAgents": function(chats, data, size, serverId) {

			if (data.AIAgentsCreativeId) this.clearCreativeChats(data.AIAgentsCreativeId, serverId);

			_.each(chats, chat => {

				this.setChat(chat, serverId);

			});

			if (data.AIAgentsCreativeId) Broadcast.call("Creative AI Chats Loaded", [data.AIAgentsCreativeId]);

			Broadcast.call("AI Chats Changed");

		},

		// Один чат (создан/изменён/удалён)
		"AIAgent": function(chat, data, size, serverId) {

			this.updateChat(chat, data.AIAgentId, serverId); // AIAgentId нужен потому что chat может быть null - что означает что чат нужно удалить с клиента

		},

		// Сервер сообщает id только что созданного этим клиентом чата
		"AIAgentCreated": function(data) {

			Broadcast.call("AI Chat Created", [data.chatId, data.versionId]);

		},

		// Полный список сообщений запрошенных чатов
		"AIAgentMessages": function(messagesByChat, data, size, serverId) {

			let agentMessages = this.getServerMap(this.AIAgentMessagesByServer, serverId || this.NodeServerId);

			_.each(messagesByChat, (messages, chatId) => {

				chatId = parseInt(chatId);

				// Даже если сообщений нет - записываем пустой массив, чтобы знать что сообщения этого чата уже запрашивались
				agentMessages[chatId] = _.map(messages, message => this.prepareMessage(message));

				Broadcast.call("AI Chat Messages Loaded", [chatId]);

			});

		},

		// Новое сообщение в чате, сообщения которого запрашивал этот клиент
		"AIAgentMessage": function(message, data, size, serverId) {

			let agentMessages = this.getServerMap(this.AIAgentMessagesByServer, serverId || this.NodeServerId);

			message = this.prepareMessage(message);

			if (!agentMessages[message["chat_id"]]) agentMessages[message["chat_id"]] = [];

			// Уже известное сообщение пришло повторно - заменяем его (например, у запроса подтверждения удаления изменился статус)
			let index = _.findIndex(agentMessages[message["chat_id"]], {id: message.id});

			if (index !== -1) {

				agentMessages[message["chat_id"]].splice(index, 1, message);

				Broadcast.call("AI Chat Message Changed", [message]);

				return;

			}

			agentMessages[message["chat_id"]].push(message);

			Broadcast.call("AI Chat Message Added", [message]);

		},

		// Сервер сообщает, что ИИ агент начал/закончил работу в чате (весь цикл общения с моделью включая вызовы инструментов)
		"AIAgentAgentState": function(state) {

			if (state.processing) this.AgentProcessing[state.chatId] = true;
			else delete this.AgentProcessing[state.chatId];

			Broadcast.call("AI Chat Agent State Changed", [state.chatId, !!state.processing]);

		}

	},

	init() {

		//Карты данных по нодам кластера: у каждой ноды своя БД, и id чатов и версий
		//на разных нодах совпадают, поэтому карты разделены по нодам (Client/Libs/Service.js, getServerMap)
		this.ChatsByServer = {};
		this.ChatsByVersionByServer = {};
		this.AIAgentMessagesByServer = {};

		// id чатов, сообщения которых уже запрошены у сервера в текущем соединении (чтобы не запрашивать повторно пока ответ ещё не пришёл)
		this.requestedAIAgents = {};
		// id чатов, в которых сейчас работает ИИ агент (по данным сервера)
		this.AgentProcessing = {};

		// Активные карты - карты рабочей ноды
		this.useServer(0);

	},

	// Активные карты данных рабочей ноды: при переключении ноды они подменяются ссылками на карты
	// этой ноды, поэтому код обращения к ним (Chats[id], AIAgentMessages[id]) не меняется
	useServer(serverId) {

		serverId = serverId || 0;

		if (this.NodeServerId === serverId) return;

		this.NodeServerId = serverId;

		this.Chats = this.getServerMap(this.ChatsByServer, serverId);
		this.ChatsByVersion = this.getServerMap(this.ChatsByVersionByServer, serverId);

		// Сообщения чатов по id чата. Ключ появляется только после запроса сообщений с сервера (даже если сообщений нет - будет пустой массив)
		this.AIAgentMessages = this.getServerMap(this.AIAgentMessagesByServer, serverId);

	},

	// serverId - нода, с которой пришли данные: пишем в карты этой ноды
	setChat(chat, serverId) {

		serverId = serverId || this.NodeServerId;

		let chats = this.getServerMap(this.ChatsByServer, serverId),
			chatsByVersion = this.getServerMap(this.ChatsByVersionByServer, serverId);

		chats[chat.id] = chat;

		if (!chatsByVersion[chat["version_id"]]) chatsByVersion[chat["version_id"]] = {};
		chatsByVersion[chat["version_id"]][chat.id] = chat;

		chat.createDate = new Date(chat["create_date"]);
		chat.lastMessageDate = new Date(chat["last_message_date"]);

	},

	unsetChat(chat, serverId) {

		serverId = serverId || this.NodeServerId;

		let chats = this.getServerMap(this.ChatsByServer, serverId),
			chatsByVersion = this.getServerMap(this.ChatsByVersionByServer, serverId),
			agentMessages = this.getServerMap(this.AIAgentMessagesByServer, serverId);

		delete chats[chat.id];

		if (chatsByVersion[chat["version_id"]]) delete chatsByVersion[chat["version_id"]][chat.id];

		delete agentMessages[chat.id];
		delete this.requestedAIAgents[chat.id];
		delete this.AgentProcessing[chat.id];

	},

	updateChat(chat, chatId, serverId) {

		serverId = serverId || this.NodeServerId;

		let oldChat = this.getServerMap(this.ChatsByServer, serverId)[chatId];

		if (chat) this.setChat(chat, serverId);
		else if (oldChat) this.unsetChat(oldChat, serverId);

		if (chat || oldChat) {

			this.broadcastChanges(oldChat, chat, ["AI Chat"]);

			Broadcast.call("AI Chats Changed", [chat ? chat["version_id"] : oldChat["version_id"]]);

		}

	},

	clearCreativeChats(creativeId, serverId) {

		_.each(this.getServerMap(this.ChatsByServer, serverId || this.NodeServerId), chat => {

			if (chat["creative_id"] === creativeId) this.unsetChat(chat, serverId);

		});

	},

	prepareMessage(message) {

		message.date = new Date(message["date"]);
		// Сообщения пользователей имеют user_id, сообщения ИИ агента - user_id = 0
		message.role = message["user_id"] ? 'user' : 'assistant';

		return message;

	},

	// Чаты версии отсортированные по дате создания
	getVersionChats(versionId) {

		return _.sortBy(_.values(this.ChatsByVersion[versionId]), chat => chat.createDate.getTime());

	},

	// Проверяем запрашивались ли уже сообщения чата с сервера (загружены либо запрос ещё в пути)
	isChatMessagesLoaded(chatId) {

		return chatId in this.AIAgentMessages || chatId in this.requestedAIAgents;

	},

	getChatMessages(chatId) {

		return this.AIAgentMessages[chatId] ? this.AIAgentMessages[chatId] : [];

	},

	// Работает ли сейчас ИИ агент в чате
	isAgentProcessing(chatId) {

		return !!this.AgentProcessing[chatId];

	},

	getSelectedChatStorageKey(versionId) {

		return `ai-chat-selected:${versionId}`;

	},

	// Последний выбранный чат версии (сохраняется в localStorage)
	getSelectedChatId(versionId) {

		return parseInt(window.localStorage.getItem(this.getSelectedChatStorageKey(versionId))) || null;

	},

	setSelectedChatId(versionId, chatId) {

		if (chatId) window.localStorage.setItem(this.getSelectedChatStorageKey(versionId), chatId + '');
		else window.localStorage.removeItem(this.getSelectedChatStorageKey(versionId));

	},

	// Запоминаем, что сообщения чата запрошены у сервера (чтобы не запрашивать повторно пока ответ ещё не пришёл)
	setChatMessagesRequested(chatId) {

		this.requestedAIAgents[chatId] = Date.now();

	}

});

window.AIAgent = AIAgent;

export { AIAgent }
